import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'grid-3x3', 'Grid3x3', [["path",{"d":"M3 8h18"}],["path",{"d":"M3 16h18"}],["path",{"d":"M8 3v18"}],["path",{"d":"M16 3v18"}]]);